import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import {
  type DocumentTypeItem,
  DocumentTypeService,
  type IDocumentTypeService,
} from '../../services/document-type/document-type.service';
import { documentTypeQueryKeys } from './query-keys';

// Riferimento stabile: un `[]` nuovo a ogni render romperebbe gli effect che dipendono dal catalogo.
const NO_DOCUMENT_TYPES: DocumentTypeItem[] = [];

export function useDocumentTypes() {
  const service = useInjection<IDocumentTypeService>(DocumentTypeService);

  const {
    data = NO_DOCUMENT_TYPES,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: documentTypeQueryKeys.list(),
    queryFn: () => service.findAll(),
  });

  return { documentTypes: data, isLoading, error, refetch };
}
